import React from "react";
import Wrapper from "../../hoc/Wrapper/Wrapper";
import BreadcrumbsTemp from "../../components/UI/BreadCrumb/BreadCrumbCustom";
import { Box, Grid } from "@material-ui/core";
import PersonList from "../../components/Person/List/PersonList";

const PersonAddPage = (props) => {
  return (
    <Wrapper>
      <BreadcrumbsTemp />

      <Box mt={2}>
        <Grid container={true}>
          <Grid item xs={12}>
            <PersonList />
          </Grid>
        </Grid>
      </Box>
    </Wrapper>
  );
};

export default PersonAddPage;
